import { useRef, useEffect } from 'react';

/**
 * Tracks the previous value of a variable before the current render took place.
 *
 * @param {object} value the value that needs to be saved
 * @returns {object} the previous value of the variable
 */
const usePrevious = (value) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

export default usePrevious;
